import {
  DollarOutlined,
  DownOutlined,
  GlobalOutlined,
  LogoutOutlined,
  QrcodeOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Lang } from "@axl-dev/school-sdk";
import { Dropdown, MenuProps } from "antd";
import { useMemo } from "react";

import { useDevice } from "@app/shared/providers/DeviceProvider";
import { useAuth, useLang, useLoc } from "@app/shared/lib/hooks";
import { Loc } from "@app/shared/ui/Loc";
import { Price } from "@app/shared/ui/Price";
import { useUIAppState } from "@app/shared/ui/UIAppState/UIAppStateProvider";
import { UserAvatar } from "@app/shared/ui/UserAvatar";

import { Header } from "../Header";

export const Account: React.FC = () => {
  const loc = useLoc();
  const { user, logout } = useAuth();
  const { lang, selectLang } = useLang();
  const { deviceSize } = useDevice();
  const { setIsProfileDrawerVisible } = useUIAppState();

  const items: MenuProps["items"] = useMemo(
    () =>
      [
        {
          key: "profile",
          onClick: () => setIsProfileDrawerVisible(true),
          label: loc.word("Profile"),
          icon: <UserOutlined />,
        },
        {
          key: "lang",
          type: "submenu",
          icon: <GlobalOutlined />,
          label: loc.word(`language.${lang}`),
          children: loc.langs
            .filter((x) => x !== lang)
            .map((x) => ({
              key: x,
              onClick: () => selectLang(x as Lang),
              label: loc.word(`language.${x}`),
            })),
        },
        {
          key: "bonus",
          onClick: () => setIsProfileDrawerVisible(true, "bonus"),
          icon: <DollarOutlined />,
          label: (
            <>
              <Loc word="Contact.bonusBalance" />
              &nbsp;
              {user?.bonusBalance && (
                <Price price={user?.bonusBalance} className="color-success" />
              )}
            </>
          ),
        },
        {
          key: "qrcode",
          onClick: () => setIsProfileDrawerVisible(true, "qrcode"),
          icon: <QrcodeOutlined />,
          label: <Loc word="QRCode.title" default="QR Code for login" />,
        },
        {
          type: "divider",
        },
        {
          key: "logout",
          onClick: () => {
            logout();
          },
          icon: <LogoutOutlined />,
          label: loc.word("Logout", { default: "Logout" }),
        },
      ] as MenuProps["items"],
    [lang, logout, selectLang, setIsProfileDrawerVisible, user?.bonusBalance],
  );

  return (
    <Header.Item>
      <Dropdown
        menu={{ items }}
        trigger={["click"]}
        placement="bottomLeft"
        overlayStyle={{ minWidth: 200 }}
      >
        <div className="flex align-center gap-5">
          <UserAvatar user={user!} size="large" />

          {deviceSize !== "mobile" && (
            <>
              <div className="fs-12 ml-5">{user?.fullName}</div>
              <DownOutlined className="mt-2" />
            </>
          )}
        </div>
      </Dropdown>
    </Header.Item>
  );
};
